module.exports = __webpack_public_path__ + "static/media/total-orders.387b0b69.svg";